import { type FunctionComponent, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { Button } from '~/ui/core/button/Button';

import type { JobItemDetails } from '../../api/use-job-item-details';
import { usePublishAction } from '../../hooks/use-publish-action';

export const VersionPublishButton: FunctionComponent<{ readonly item: JobItemDetails }> = ({ item }) => {
    const { translate } = useContext(ApplicationContext);
    const { handlePublish } = usePublishAction({
        architectureId: item.architectureId,
        item,
        itemType: item.type,
    });

    return (
        <Button variant="primary" onClick={handlePublish}>
            {translate('pages.job-architecture-v2.job-role-publish-button')}
        </Button>
    );
};
